import React, { useId } from 'react';
import { X } from 'lucide-react';

const beijingInput = (value) => value
  ? new Date(new Date(value).getTime() + 8 * 60 * 60 * 1000).toISOString().slice(0, 16)
  : '';

export const editableLeavePeriods = (periods = []) => periods.map(period => ({
  start_at: beijingInput(period.start_at),
  end_at: beijingInput(period.end_at)
}));

export const serializeLeavePeriods = (periods = []) => periods.map((period, index) => {
  if (!period.start_at || !period.end_at) {
    throw new Error(`请填写第 ${index + 1} 段休假的开始和结束时间`);
  }
  const start = `${period.start_at}:00+08:00`;
  const end = `${period.end_at}:00+08:00`;
  if (!Number.isFinite(Date.parse(start)) || !Number.isFinite(Date.parse(end))) {
    throw new Error(`第 ${index + 1} 段休假时间格式无效`);
  }
  if (Date.parse(end) <= Date.parse(start)) {
    throw new Error(`第 ${index + 1} 段休假结束时间必须晚于开始时间`);
  }
  return { start_at: start, end_at: end };
});

export const personLeaveStatus = (periods = [], now = Date.now()) => {
  if (periods.some(period => Date.parse(period.start_at) <= now && now < Date.parse(period.end_at))) {
    return '休假中';
  }
  const upcoming = periods.filter(period => Date.parse(period.start_at) > now).length;
  return upcoming ? `${upcoming} 段待休假` : '';
};

export default function PersonLeaveEditor({ periods = [], onChange, disabled = false }) {
  const id = useId();
  const update = (index, field, value) => onChange(periods.map((period, i) => (
    i === index ? { ...period, [field]: value } : period
  )));
  return (
    <div className="form-group">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
        <span className="form-label">休假时间（北京时间）</span>
        <button type="button" className="btn btn-ghost" disabled={disabled}
          onClick={() => onChange([...periods, { start_at: '', end_at: '' }])}>添加休假</button>
      </div>
      <small style={{ color: 'var(--text-muted)' }}>休假期间不分配工单，结束时自动恢复。可提前添加多段。</small>
      {periods.map((period, index) => (
        <div key={index} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'end', gap: '8px', marginTop: '12px' }}>
          {['start_at', 'end_at'].map((field) => (
            <div key={field} style={{ flex: '1 1 180px', minWidth: 0 }}>
              <label className="form-label" htmlFor={`${id}-${index}-${field}`}>
                第 {index + 1} 段{field === 'start_at' ? '开始' : '结束'}
              </label>
              <input id={`${id}-${index}-${field}`} type="datetime-local" className="form-input"
                required step="60" disabled={disabled} value={period[field]}
                onChange={event => update(index, field, event.target.value)} />
            </div>
          ))}
          <button type="button" className="table-action-icon-button is-danger" disabled={disabled}
            aria-label={`删除第 ${index + 1} 段休假`} title="删除休假"
            onClick={() => onChange(periods.filter((_, i) => i !== index))}>
            <X size={19} aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
}
